import { filterXSS } from 'xss'

export function preventXss(value: string, options = {}): string {
  const excelFormulaRegex = /^([=+\-@])(.*)$/gi // Formula starts with +, -, = or @
  const filtered = filterXSS(value, {
    ...options,
    whiteList: {},
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script'],
  })
  if (excelFormulaRegex.test(filtered)) {
    return filtered.replace(excelFormulaRegex, "'$1$2'")
  }
  return filtered
}

export function stripHtmlTags(input: string): string {
  let result = input
  let prev: string
  do {
    prev = result
    result = result.replace(/<(script|style|xmp|textarea|noscript|iframe|object|embed|applet)[^>]*>[\s\S]*?<\/\1>/gi, '')
  } while (result !== prev)
  return result.replace(/<[^>]*(?:>|$)/g, '')
}

export function sanitizeInput(value: string) {
  const sanitized = stripHtmlTags(replaceEmoticonsWithEmojis(value))
  return sanitized
    .replace(/^([=+-@<>])(.*)$/, '\\$1$2') // Prepend a space if the string starts with =, +, -, or @
    .replace(/:/g, '\\$&')
    .replace(/[";]/g, '') // Remove double quotes dots and semicolons
    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
    .replace(/&amp/g, '&') // allow the & character
    .trim() // Trim leading and trailing spaces
}

function replaceEmoticonsWithEmojis(inputString: string): string {
  const map: { [key: string]: string } = {
    '<3': '\u2764\uFE0F',
    '</3': '\uD83D\uDC94',
    ':D': '\uD83D\uDE00',
    ':)': '\uD83D\uDE03',
    ';)': '\uD83D\uDE09',
    ':(': '\uD83D\uDE12',
    ':p': '\uD83D\uDE1B',
    ';p': '\uD83D\uDE1C',
    ":'(": '\uD83D\uDE22',
  }

  const escapeSpecialChars = (regex: string): string => {
    return regex.replace(/([()[{*+.$^\\|?])/g, '\\$1')
  }

  let resultString = inputString
  Object.keys(map).forEach((emoticon) => {
    const regex = new RegExp(escapeSpecialChars(emoticon), 'gim')
    resultString = resultString.replace(regex, map[emoticon])
  })
  return resultString
}
